import { useUserProfile } from '@/context/UserProfileContext';
import { useAppNavigation } from '@/lib/i18nNavigation';
import { IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddActionSheet from './AddActionSheet';
import { GolfAvatar } from './ui/GolfAvatar';

// Pages
import GolfRouter from './GolfRouter';
import GolfIcon from './GolfIcon';

export default function MobileNav() {
  const { getCurrentPathname } = useAppNavigation();
  const pathname = getCurrentPathname();
  const [showCaptions] = useState(false);
  const { profile } = useUserProfile();
  const { t } = useTranslation('MGP');

  return (
    <IonTabs>
      <IonRouterOutlet>
        <GolfRouter hasProfile={!!profile} />
      </IonRouterOutlet>

      <IonTabBar color="transparent" slot="bottom" className="bg-card pb-safe dark:border-gray-600 md:hidden">
        {/* Home Tab Button */}
        <IonTabButton tab="dashboard" href="/dashboard" selected={pathname === "/dashboard" || pathname === "/"}>
          <GolfIcon name={pathname === "/dashboard" || pathname === "/" ? "home-filled" : "home"} className="size-6" />
          {showCaptions && <IonLabel className={`${(pathname === "/dashboard" || pathname === "/") ? 'text-primary' : ''}`}>{t('home')}</IonLabel>}
        </IonTabButton>

        {/* Search Tab Button */}
        <IonTabButton tab="search" href="/clubs" selected={pathname.startsWith('/clubs')}>
          <GolfIcon name={pathname.startsWith('/clubs') ? "search-filled" : "search"} className="size-6" />
          {showCaptions && <IonLabel className={`${(pathname.startsWith('/clubs') ? 'text-primary' : '')}`}>{t('discover')}</IonLabel>}
        </IonTabButton>

        {/* Add Action Button */}
        <IonTabButton tab="action">
          <AddActionSheet />
          {showCaptions && <IonLabel>{t('add')}</IonLabel>}
        </IonTabButton>

        {/* Notifications Tab Button */}
        <IonTabButton tab="notifications" href="/notifications" selected={pathname === "/notifications"}>
          <GolfIcon name={pathname === "/notifications" ? "notification-filled" : "notification"} className="size-6" />
          {showCaptions && <IonLabel className={`${(pathname === "/notifications" ? 'text-primary' : '')}`}>{t('notifications')}</IonLabel>}
        </IonTabButton>

        {/* Profile Tab Button */}
        <IonTabButton
          tab="profile"
          href={profile ? `/u/${profile.username}` : '/welcome'}
          selected={pathname.includes('/u/') || pathname === "/profile"}
        >
          <div className={`flex flex-col items-center justify-center rounded-full ${pathname.includes('/u/') || pathname === "/profile" ? 'border-2 border-primary bg-background' : ''}`}>
            <GolfAvatar className="transition-all duration-300" size={28} imageUrl={profile?.imageUrl} />
            {showCaptions && <IonLabel className={`${pathname.includes('/u/') || pathname === "/profile" ? 'text-primary' : ''}`}>{t('profile')}</IonLabel>}
          </div>
        </IonTabButton>
      </IonTabBar>
    </IonTabs >
  );
};
